import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(1),
  },
}));

const ConfirmButton = ({ basePath, ...props }) => {
  const translate = useTranslate();
  const classes = useStyles();
  return (
    <Button
      {...props}
      color="secondary"
      variant="contained"
      className={classes.button}
    >
      {translate("ra.button.confirm")}
    </Button>
  );
};
export default ConfirmButton;
